export enum EventListenerStrategy {
  Browser = 'browser',
}

export const getEventListenerStrategy = (strategy: EventListenerStrategy) => {
  switch (strategy) {
    case EventListenerStrategy.Browser:
      return window.addEventListener;
    default:
      return window.addEventListener;
  }
};
